import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f1caa09a")

_pushScopeId("data-v-f1caa09a")
const _hoisted_1 = { class: "flex1 display-flex justify-content-between info-title-havbutton-bottom" }
const _hoisted_2 = { class: "info-light-title" }
const _hoisted_3 = { class: "info-label-title vertical-align-top" }
const _hoisted_4 = { class: "info-label-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_payment_records_dialog = _resolveComponent("payment-records-dialog")
  const _component_apartment_clickpay_dialog = _resolveComponent("apartment-clickpay-dialog")
  const _component_apartment_edit_dialog = _resolveComponent("apartment-edit-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$wordList.DeviceDetailDetailBasic), 1),
      _createVNode(_component_cus_button, {
        type: "blue",
        onClick: _ctx.edit
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$wordList.TabelConfigInHtmlModify), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.basicInformationData, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "info-item info-item-bottom",
        key: item.name
      }, [
        _createVNode("label", _hoisted_3, _toDisplayString(item.label), 1),
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.filterEmptyCellValue(item.value)), 1),
        (item.name === 'FinalCommunalFee')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_svg_icon, {
                name: "icon-record",
                class: "m-left-right-xl cursor-pointer",
                color: "color-warning",
                fontSize: "29px",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowPaymentRecords = true))
              }),
              _createVNode(_component_cus_button, {
                class: "m-left-xl",
                type: "blue",
                onClick: _ctx.sendClickPaysApi
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.SendTheClickpays), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.isShowPaymentRecords)
      ? (_openBlock(), _createBlock(_component_payment_records_dialog, {
          key: 0,
          UUID: _ctx.basicInformationEditForm.UUID,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowPaymentRecords = false))
        }, null, 8, ["UUID"]))
      : _createCommentVNode("", true),
    (_ctx.isShowClickpayDialog)
      ? (_openBlock(), _createBlock(_component_apartment_clickpay_dialog, {
          key: 1,
          sendStatus: _ctx.sendStatus,
          UUID: _ctx.basicInformationEditForm.UUID,
          communalFee: _ctx.basicInformationEditForm.FinalCommunalFee,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowClickpayDialog = false))
        }, null, 8, ["sendStatus", "UUID", "communalFee"]))
      : _createCommentVNode("", true),
    (_ctx.isShowApartmentEditDialog)
      ? (_openBlock(), _createBlock(_component_apartment_edit_dialog, {
          key: 2,
          onSuccess: _ctx.success,
          "init-form": _ctx.initForm,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowApartmentEditDialog=false))
        }, null, 8, ["onSuccess", "init-form"]))
      : _createCommentVNode("", true)
  ]))
})